import BaseView from '../views/BaseView';
import SoundtrackChapters from '../components/SoundtrackChapters';

export default class Soundtrack extends BaseView {
	constructor(container) {
		super(container);
	}

	init() {
		const groups = new Map([[SoundtrackChapters, this.container.querySelectorAll('[data-soundtracks-chapters]')]]);
		super.createModules(groups);
	}
}
